export default {
  getChartData: "hrmis/company_structure",
  postOrgChart: "cu/hrmis_cu/HRMManager_setOrgChart",
  getp9: "hrmis/payroll/p9Report",
};
